var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 31,
    viewBox: "0 0 39 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7098 4.00147C32.9976 3.43022 32.1504 2.97721 31.2171 2.66867C30.2838 2.36014 29.283 2.2022 28.2726 2.20399H10.7049C9.69435 2.20291 8.69346 2.36076 7.75957 2.6685C6.82569 2.97623 5.97715 3.42781 5.26259 3.99735C4.54802 4.5669 3.98146 5.24322 3.59536 5.98757C3.20927 6.73192 3.01122 7.52967 3.01258 8.33513V25.8421C3.01258 26.3933 3.23019 26.9306 3.63458 27.3778C4.03898 27.825 4.60965 28.1594 5.26577 28.3338C5.92189 28.5081 6.6302 28.5134 7.29035 28.3491C7.95051 28.1847 8.52904 27.859 8.94401 27.418L10.2209 26.0062C10.529 25.681 10.9272 25.4169 11.3845 25.2347C11.8418 25.0524 12.3458 24.9569 12.8571 24.9557H28.2726C30.3084 24.9535 32.2603 24.3091 33.7017 23.1633C35.1431 22.0175 35.9568 20.4635 35.965 18.8409V8.33513C35.9672 7.52981 35.7691 6.73213 35.382 5.98826C34.9949 5.24439 34.4265 4.5691 33.7098 4.00147ZM33.7613 18.8409C33.7586 20.0005 33.1794 21.112 32.1507 21.9319C31.122 22.7519 29.7275 23.2135 28.2726 23.2156H12.8983C12.0458 23.2166 11.2051 23.3749 10.4422 23.6782C9.67932 23.9816 9.01496 24.4216 8.50121 24.9639L7.18312 26.3674C7.04372 26.5127 6.85085 26.6197 6.63145 26.6735C6.41206 26.7272 6.17708 26.725 5.95934 26.6671C5.74159 26.6093 5.55195 26.4987 5.41689 26.3508C5.28183 26.2029 5.20809 26.025 5.20597 25.8421V8.33513C5.20462 7.75925 5.34592 7.18883 5.62179 6.65659C5.89766 6.12434 6.30265 5.64074 6.81355 5.23354C7.32444 4.82633 7.93118 4.50353 8.59895 4.28365C9.26672 4.06378 9.98239 3.95115 10.7049 3.95223H28.2726C29.7283 3.95223 31.1244 4.41313 32.1537 5.23355C33.183 6.05396 33.7613 7.16668 33.7613 8.32692V18.8409Z",
    fill: "#181A20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.785 7.45691L13.6294 8.28588L14.8754 8.66344L14.1442 9.55807L14.0825 10.6251L12.785 10.346L11.4978 10.6251L11.436 9.55807L10.7048 8.66344L11.9508 8.28588L12.785 7.45691Z",
    fill: "#181A20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2839 7.45691L19.118 8.28588L20.3743 8.66344L19.6432 9.55807L19.5711 10.6251L18.2839 10.346L16.9864 10.6251L16.9246 9.55807L16.1935 8.66344L17.4395 8.28588L18.2839 7.45691Z",
    fill: "#181A20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7725 7.45691L24.617 8.28588L25.863 8.66344L25.1318 9.55807L25.07 10.6251L23.7725 10.346L22.4853 10.6251L22.4133 9.55807L21.6821 8.66344L22.9384 8.28588L23.7725 7.45691Z",
    fill: "#181A20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7048 17.9628H19.4887V19.711H10.7048V17.9628Z",
    fill: "#181A20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7048 13.5881H29.3744V15.3364H10.7048V13.5881Z",
    fill: "#181A20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviews);
export default __webpack_public_path__ + "static/media/reviews.af510537fccfdc02c4c6180aabaac76d.svg";
export { ForwardRef as ReactComponent };